import React from 'react';
import '../../../css/statsTable.css';

function StateLine(props){
  return (
    <table className="statsTable">
      <thead>
        <tr>
          <th>Move</th><th>Fight</th><th>Shoot</th><th>Armor</th><th>Will</th><th>Health</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{props.stats.move}</td>
          <td>+{props.stats.fight}</td>
          <td>+{props.stats.shoot}</td>
          <td>{props.stats.armor}</td>
          <td>+{props.stats.will}</td>
          <td>{props.stats.health}</td>
        </tr>
      </tbody>
    </table>
  );
}

export default StateLine;
